<div class="tw-block tw-bg-gray-100">
  <!-- Regimen Hero-->
  @if (is2499Upsell) {
    <section class="tw-bg-grid-layout tw-bg-repeat-x tw-bg-top" [ngClass]="backgroundColor" (click)="clickOnRegimenImage()">
      <div class="tw-pb-8 tw-mb-2">
        @if (regimen?.regimenCoverImage) {
          <img class="tw-mb-5 tw-block" [src]="regimen?.regimenCoverImage" appPinchZoom="appPinchZoom" />
        }
        @if (appConfig.Shared.Regimen.Class.FACE === regimen.class) {
          <h3 class="tw-font-lexend tw-font-bold tw-text-center tw-text-500 tw-text-gray-900 tw-mb-4" i18n="@@skinRoutineReadyV2">
        {{patientName}}, your personalised skin <br />routine is ready
      </h3>
        }
        @if (appConfig.Shared.Regimen.Class.HAIR === regimen.class) {
          <h3 class="tw-font-lexend tw-text-center tw-font-bold tw-text-500 tw-text-gray-900 tw-mb-4" i18n="@@hairRoutineReadyV2">
        {{patientName}}, your personalised hair <br />routine is ready
      </h3>
        }
        <!-- Regimen offer banner -->
        @if (((newRegimenPricingExperiment && !regimen?.orderPlaced) || regimen?.extraProducts?.length)) {
          <app-regimen-offer-product-banner appTrackScrollDepth="regimen_offer" (click)="$event?.stopPropagation(); regimenOfferProductEvent();" class="tw-mx-4 tw-mb-4">
            <app-regimen-offer-tag><span i18n="@@limitedTimeOfferPouch">Limited time offer</span></app-regimen-offer-tag>
            <regimen-offer-product-title><span i18n="@@freePouch">+ Free Pouch</span></regimen-offer-product-title>
            <regimen-offer-product-caption><span i18n="@@withYourPurchase">with your treatment kit purchase</span></regimen-offer-product-caption>
          </app-regimen-offer-product-banner>
        }
        <!-- Regimen offer banner -->
        <!-- Regimen Tags -->
        @if (newRegimenIconsExperiment && doesAllTagsContainRebrandedImages) {
          <ul appTrackScrollDepth="regimen_tags" class="tw-px-4 tw-flex tw-flex-row tw-justify-between tw-items-start tw-gap-1">
            @for (item of regimen.regimenTag; track item) {
              <li class="tw-flex-1 tw-flex tw-flex-col tw-items-center tw-gap-1.5" (click)="trackTrustBuildingIconClick($event)">
                <div class="tw-relative tw-z-[1] gradient-border after:tw-content-[''] after:tw-absolute after:tw-w-full after:tw-h-full after:tw-top-1/2 after:tw-left-1/2 after:tw-rounded-full after:tw-p-[21.5px] after:tw-z-[-1]  after:[background-image:linear-gradient(to_right,var(--from-color)_10%,var(--to-color)_100%)] after:tw-animate-rotate"
                  [style.--from-color]="getFromColor()"
                  [style.--to-color]="getToColor()">
                  <img class="tw-h-10 tw-w-10" [src]="item.rebrandedImageV2" />
                </div>
                <p class="tw-font-lexend tw-text-200 tw-text-gray-900 tw-text-center tw-break-words tw-leading-3">
                  {{ item.title }}
                </p>
              </li>
            }
          </ul>
        }
        @if (!newRegimenIconsExperiment || (newRegimenIconsExperiment && !doesAllTagsContainRebrandedImages)) {
          <ul appTrackScrollDepth="regimen_tags" class="tw-px-4 tw-flex tw-flex-row tw-justify-between tw-items-start tw-gap-1">
            @for (item of regimen.regimenTag; track item) {
              <li class="tw-flex-1 tw-flex tw-flex-col tw-items-center tw-gap-1.5" (click)="trackTrustBuildingIconClick($event)">
                <img class="tw-h-10 tw-w-10" [src]="item.rebrandedImage" />
                <p class="tw-font-lexend tw-text-200 tw-text-gray-900 tw-text-center tw-break-words tw-leading-3">
                  {{ item.title }}
                </p>
              </li>
            }
          </ul>
        }
      </div>
    </section>
  }
  @if (!is2499Upsell) {
    <section class="tw-bg-grid-layout tw-bg-repeat-x tw-bg-top" [ngClass]="{'tw-bg-orange-100':  appConfig.Shared.Regimen.Class.HAIR === regimen.class, 'tw-bg-purple-100':  appConfig.Shared.Regimen.Class.FACE === regimen.class }" (click)="clickOnRegimenImage()">
      <div class="tw-pb-8 tw-mb-2">
        @if (regimen?.regimenCoverImage) {
          <img class="tw-block tw-mb-5" [src]="regimen?.regimenCoverImage" appPinchZoom="appPinchZoom" />
        }
        @if (appConfig.Shared.Regimen.Class.FACE === regimen.class) {
          <h3 class="tw-font-body tw-font-bold tw-text-center tw-text-500 tw-text-gray-900 tw-mb-4" i18n="@@skinRoutineReadyV2">
        {{patientName}}, your personalised skin <br />routine is ready
      </h3>
        }
        @if (appConfig.Shared.Regimen.Class.HAIR === regimen.class) {
          <h3 class="tw-font-body tw-font-bold tw-text-center tw-text-500 tw-text-gray-900 tw-mb-4" i18n="@@hairRoutineReadyV2">
        {{patientName}}, your personalised hair <br />routine is ready
      </h3>
        }
        <!-- Regimen offer banner -->
        @if (((newRegimenPricingExperiment && !regimen?.orderPlaced) || regimen?.extraProducts?.length)) {
          <app-regimen-offer-product-banner appTrackScrollDepth="regimen_offer" (click)="$event?.stopPropagation(); regimenOfferProductEvent();" class="tw-mx-4 tw-mb-4">
            <app-regimen-offer-tag><span i18n="@@limitedTimeOfferPouch">Limited time offer</span></app-regimen-offer-tag>
            <regimen-offer-product-title><span i18n="@@freePouch">+ Free Pouch</span></regimen-offer-product-title>
            <regimen-offer-product-caption><span i18n="@@withYourPurchase">with your treatment kit purchase</span></regimen-offer-product-caption>
          </app-regimen-offer-product-banner>
        }
        <!-- Regimen offer banner -->
        @if (regimen.regimenTag && regimen.regimenTag[0]?.rebrandedImage) {
          <ul appTrackScrollDepth="regimen_tags" class="tw-px-4 tw-flex tw-flex-row tw-justify-between tw-items-start tw-gap-1">
            @for (item of regimen.regimenTag; track item) {
              <li class="tw-flex-1 tw-flex tw-flex-col tw-items-center tw-gap-1.5" (click)="trackTrustBuildingIconClick($event)">
                <img class="tw-h-10 tw-w-10" [src]="item.rebrandedImage" />
                <p class="tw-font-body tw-text-200 tw-text-gray-900 tw-text-center tw-break-words">
                  {{ item.title }}
                </p>
              </li>
            }
          </ul>
        }
      </div>
    </section>
  }
  @if (!regimenRehaulV1Experiment || ( regimenRehaulV1Experiment && !removeVariants)) {
    @if (is2499Upsell && !regimen?.orderPlaced && !isKeyboardVisible) {
      <choose-plan
        [class]="choosePlanClasses"
        style="background: rgba(255, 255, 255, 1)"
        [regimen]="regimen"
        (onSelectPlan)="changeRegimenKitInfo($event)"
        (onReadMore)="readMoreAboutPlans()"
        (hideVariants)="is2499Upsell = false">
      </choose-plan>
    }
  }
  <!-- Kit items-->
  @if (showProductImageCarousel) {
    <app-regimen-products-slider appTrackScrollDepth="regimen_product_slider" [regimen]="regimen" [products]="products"></app-regimen-products-slider>
  } @else {
    @if (regimen.morning[0]?.product?.title) {
      <product-list appTrackScrollDepth="products_list" [regimenRehaulV3Experiment]="regimenRehaulV3Experiment" [products]="products" [showSingleCtaProducts]="true" [showViewMore]="true" (onClick)="readMoreAboutProducts()" (onReadMoreClick)="readMoreAboutProducts()" (onInstructionClick)="seeInstructions()"></product-list>
    }
  }
  <!-- Doctor card-->
  @if(allocatedDoctor) {
    <section appTrackScrollDepth="regimen_doctor_details" class="tw-my-6">
      <app-regimen-doctor-details-card
        [regimen]="regimen"
        [allocatedDoctor]="allocatedDoctor"
        [user]="user"
        [reportPageView]="true"
        (readMoreClick)="readMoreAboutDoctor()">
      </app-regimen-doctor-details-card>
    </section>
  }
  @if (shouldShowPendingCallBannerContainer) {
    <div appTrackScrollDepth="unpaid_doctor_call" [ngClass]="doctorCallBannerContainerClasses">
      <app-unpaid-user-doctor-call-banner-container
        [bannerState]="pendingCallBannerState"
        [regimen]="regimen"
        [pendingCalls]="this.unpaidUserDoctorCalls"
        viewMode="regimen"
        (callCreated)="onPendingCallCreated()">
      </app-unpaid-user-doctor-call-banner-container>
    </div>
  }
  @if (shouldShowChatBanner) {
    <div [ngClass]="chatBannerContainerClasses">
      <app-user-query-chat-banner
        appTrackScrollDepth="unpaid_user_ai_chat"
        [user]="user"
        [showHeader]="!pendingCallBannerExperiment || (pendingCallBannerExperimentVariantData?.newBannerUI || pendingCallState)"
        [regimen]="regimen">
      </app-user-query-chat-banner>
    </div>
  }
  <!-- Services-->
  <regimen-value-proposition-v2 [regimenUpdateTrigger]="regimenUpdateTrigger()" [user]="user" [allocatedDoctorImage]="allocatedDoctor?.DoctorImageThumbnail || allocatedDoctor?.doctorDisplayImage || defaultDoctorImageThumbnail" [backgroundColor]="backgroundColor" [showMoneyBack]="showMoneyBackGuaranteeBanner" [moneyBackTitleText]="moneyBackText" [moneyBackSubtitleText]="guaranteeText" [moneyBackActionText]="seeDetailsText" (readMoreClick)="readMoreAboutServices()" (moneyBackClick)="onRegimenMoneyBackClick()"></regimen-value-proposition-v2>
  @if (showMoneyBackGuaranteeBanner && !showRegimenValuePropV3) {
    <div class="tw-p-4">
      <cure-money-back
        appTrackScrollDepth="money_back_guarantee"
        percentText="100%"
        [titleText]="moneyBackText"
        [subtitleText]="guaranteeText"
        [actionText]="seeDetailsText"
        [interactive]="true"
        (curePress)="onRegimenMoneyBackClick()">
      </cure-money-back>
    </div>
  }
  <app-improvement-timeline [placement]="ImprovementTimelinePlacement.REGIMEN" [regimenClass]="regimen.class"></app-improvement-timeline>
  @if (showRegimenExploreBanner) {
    <app-regimen-explore-banner appTrackScrollDepth="regimen_explore" [posts]="regimenFaqPosts"></app-regimen-explore-banner>
  }
  <testimonial-wall appTrackScrollDepth="testimonial" [regimen]="regimen"></testimonial-wall>
  @if (!showRegimenExploreBanner) {
    <app-faq-section appTrackScrollDepth="regimen_faq" [noBottomMargin]="restartRegimenChatUiExperiment"></app-faq-section>
  }
  @if (!regimen.orderPlaced) {
    @if (restartRegimenChatUiExperiment) {
      <div class="tw-mt-2" [class.tw-pb-5]="!showRefundPolicyOption" [style.marginBottom.px]="startAgainMarginBottomPx">
        <app-reanswer-regimen-question-banner
          appTrackScrollDepth="reanswer_regimen_question"
          [regimenClass]="regimen.class"
          (reanswerClick)="openChangeRegimenAnswerSheet()">
        </app-reanswer-regimen-question-banner>
        @if (showRefundPolicyOption) {
          <refund-policy appTrackScrollDepth="refund_policy"></refund-policy>
        }
      </div>
    } @else {
      <div appTrackScrollDepth="reanswer_regimen_question" class="tw-mt-6 tw-mx-6 tw-font-body tw-text-300 tw-pb-2"
           [style.marginBottom.px]="startAgainMarginBottomPx"
           (click)="startAgain()">
        <div class="tw-text-gray-500" i18n="@@forgotToShare"> Forgot to share some important information? </div>
        <div class="tw-text-gray-500" i18n="@@neverLate"> It's never too late! Simply re-answer the questions. </div>
        <hr class="tw-my-1" />
        <div class="tw-font-bold tw-text-gray-700" i18n="@@changeAnswers"> + Click Here to Change the answers </div>
        @if (showRefundPolicyOption) {
          <refund-policy appTrackScrollDepth="refund_policy"></refund-policy>
        }
      </div>
    }
  }
</div>

<!-- Route-mode Buy Now footer (rendered by the parent monolith in legacy mode). -->
@if (isRouteMode && regimen.totalSP && !regimen.active && !regimen.orderPlaced && !isKeyboardVisible) {
  <div class="tw-h-26"></div>
  <div class="tw-fixed tw-bottom-0 tw-left-0 tw-right-0 tw-bg-white tw-py-5 tw-z-[11]">
    <button class="tw-border-none tw-w-full tw-h-[54px] tw-relative tw-text-[#ffffff] tw-text-[18px] tw-capitalize tw-p-4 shine loop tw-bg-teal-600 tw-overflow-visible tw-mb-2 tw-rounded-3"
      (click)="buyRegimen()">
      <div class="tw-absolute tw-flex tw-items-center tw-justify-center tw-top-[-15px] tw-left-[10px] tw-text-orange-400">
        <svg class="tw-w-[85px] tw-h-[85px] tw-relative tw-animate-spin_slow" xmlns="http://www.w3.org/2000/svg" width="64.443" height="67.447" viewBox="0 0 64.443 67.447">
          <path d="M87.025,208.059,79.5,203.146l-2.347-8.676a3.039,3.039,0,0,0-3.088-2.243l-8.976.449-7-5.639a3.042,3.042,0,0,0-3.817,0l-7,5.639-8.975-.449a3.031,3.031,0,0,0-3.088,2.243l-2.347,8.676-7.525,4.912a3.042,3.042,0,0,0-1.179,3.63l3.2,8.4-3.2,8.4a3.042,3.042,0,0,0,1.179,3.63l7.525,4.913,2.347,8.675a3.034,3.034,0,0,0,3.088,2.243l8.975-.449,7,5.639a3.041,3.041,0,0,0,3.817,0l7-5.639,8.976.449a3.036,3.036,0,0,0,3.088-2.243l2.347-8.675,7.525-4.913a3.042,3.042,0,0,0,1.179-3.63l-3.2-8.4,3.2-8.4A3.042,3.042,0,0,0,87.025,208.059Z"
          transform="translate(-23.961 -186.363)" fill="#D66736"></path>
        </svg>
        <span class="tw-absolute tw-font-body tw-text-650 tw-text-white tw-z-20 tw-font-bold tw-leading-none">{{regimen.discount}}%<br />Off </span>
      </div>
      <span class="tw-ml-20 tw-font-lexend tw-font-bold tw-text-400 tw-leading-[20px]">
        <span [style.fontSize.px]="user?.get('languagePreference') === 'ta' || user?.get('languagePreference') === 'ml' ? 12 : 18" i18n="@@buyNow">Buy Now</span>
        <span> &#64;</span>
        <span class="tw-text-200 tw-line-through">₹{{regimen.totalMRP}}</span>
        <span>₹{{regimen.totalSP}}</span>
      </span>
    </button>
  </div>
}

<!-- Route-mode order-placed footer (Check Order Details); rendered by the parent monolith in legacy mode. -->
@if (isRouteMode && !regimen.active && regimen.orderPlaced && !isKeyboardVisible) {
  <div class="tw-h-26"></div>
  <div class="tw-fixed tw-bottom-0 tw-left-0 tw-right-0 tw-bg-white tw-py-5 tw-px-4 tw-z-[11]">
    <button class="tw-w-full tw-p-4 tw-bg-teal-600 tw-text-white tw-font-lexend tw-font-bold tw-text-400 tw-leading-[20px] tw-rounded-3"
      [disabled]="conn.isInternalUser()"
      (click)="openRegimenOrderStatus()">
      <span i18n="@@checkOrderDetails">Check Order Details</span>
    </button>
  </div>
}
